import React from "react"

const LivescoringFilterGenderButton = ({
    value,
    filters,
    updateFilters
}) => {
    return (
        <button className={`livescoring-filter-button ${filters.gender === value && "livescoring-filter-button-active"}`}
            onClick={() => updateFilters("gender", value)}>
            <label className="livescoring-filter-gender-label">
                { "male" === value ? "Masculino" : "Femenino" }
            </label>
        </button>
    )
}

export default LivescoringFilterGenderButton
